import { gql } from '@zenbusiness/application-commons-graphql';

export const GET_BANKING_WIDGET = gql`
  query bankingWidget(
    $input: BankAccountInput!
    $businessEntityUuid: UUID!
    $params: TransactionInput!
  ) {
    bankAccountStatus(input: $input) {
      accountHasLinkedBankAccount
      accountHasPayment
      accountHasTransaction
    }
    bankCustomerAddress(businessEntityUuid: $businessEntityUuid) {
      address1
      address2
      city
      state
      zip
      country
    }
    transactions(params: $params) {
      data {
        id
        type
        direction
        createdAt
        summary
        amount {
          amount
          currency
          formattedAmount
        }
        balance {
          amount
          currency
          formattedAmount
        }
      }
    }
  }
`;
